import { AutocompleteDropdown, Box } from '@common-fe/common-fe';
import styled from 'styled-components';



export const StyledAutocompleteDropdown = styled(AutocompleteDropdown)`
  &.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    padding-right: ${({ theme }) => theme.spacings.spacing24};
  }
`;

export const FixedWrapper = styled(Box) <{ isScrolled?: boolean }>`
  position: fixed;
  z-index: 1001;
`;

export const TableWithBacklighting = styled(Box)`
  .backlighting_ {
    &uploading {
      border: 2px solid ${({ theme }) => theme.colors.border};
    }
    &uploaded, &approved, &validated {
      border: 2px solid ${({ theme }) => theme.colors.accentActive};
      box-shadow: 0px 6px 16px rgba(23, 106, 246, 0.5);
      ${({ theme }) => theme.shadows.primary};
    }
    &error {
      border: 2px solid ${({ theme }) => theme.colors.danger};
      ${({ theme }) => theme.shadows.error};
    }
    &processing {
      border: 2px solid ${({ theme }) => theme.colors.warning};
      ${({ theme }) => theme.shadows.warning};
    }
    &completed {
      border: 2px solid ${({ theme }) => theme.colors.success};
      ${({ theme }) => theme.shadows.success};
    }
  }
  .warning_completed {
    border: 2px solid ${({ theme }) => theme.colors.warning};
    ${({ theme }) => theme.shadows.warning};
  }
`;